module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_15.c7e464f5.jpeg";